import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { schemaRequiresTrueValue, FormContextType, RJSFSchema, StrictRJSFSchema, WidgetProps } from '@rjsf/utils';
import useLinkifiedLabel from './useLinkifiedLabel';

/** The `CheckBoxWidget` is a widget for rendering boolean properties.
 *  It is typically used to represent a boolean.
 *
 * @param props - The `WidgetProps` for this component
 */
export default function CheckboxWidget<T = any, S extends StrictRJSFSchema = RJSFSchema, F extends FormContextType = any>(props: WidgetProps<T, S, F>) {
  const { schema, id, value, disabled, readonly, label, onChange, onBlur, onFocus } = props;
  // Because an unchecked checkbox will cause html5 validation to fail, only add
  // the "required" attribute if the field value must be "true", due to the
  // "const" or "enum" keywords
  const required = schemaRequiresTrueValue<S>(schema);

  const _onChange = (_: any, checked: boolean) => onChange(checked);
  const _onBlur = ({ target: { value: val } }: React.FocusEvent<HTMLButtonElement>) => onBlur(id, val);
  const _onFocus = ({ target: { value: val } }: React.FocusEvent<HTMLButtonElement>) => onFocus(id, val);

  const displayLabel = useLinkifiedLabel(label);

  return (
    <FormControlLabel
      control={
        <Checkbox
          id={id}
          name={id}
          checked={typeof value === 'undefined' ? false : Boolean(value)}
          required={required}
          disabled={disabled || readonly}
          onChange={_onChange}
          onBlur={_onBlur}
          onFocus={_onFocus}
          inputProps={{ 'data-testid': 'root_test_checkbox_field' }}
        />
      }
      label={displayLabel || ''}
    />
  );
}
